import { decode } from 'jsonwebtoken';
import { Role } from '../constants/define/role';
import { TOKEN_KEY, TokenRepository } from '../repository/web-storage/token';

export const isValidToken = () => {
  try {
    const localToken = localStorage.getItem(TOKEN_KEY);
    if (localToken && localToken !== 'undefined') {
      const token = JSON.parse(localToken);
      if (
        !token?.role ||
        ![Role.ADMIN, Role.SUPER_ADMIN, Role.CUSTOMER_SERVICE, Role.TTB_AGENT, Role.TTB_MANAGER].includes(token.role)
      ) {
        TokenRepository.remove();
        return undefined;
      }
      const today = new Date();
      const result = decode(token.idToken, { json: true, complete: true });
      if (
        !result ||
        !result?.payload ||
        !result!.payload?.iat ||
        Math.floor((today.getTime() / 1000 - Number(result!.payload?.iat)) / 3600) >= 1
      ) {
        TokenRepository.remove();
        return false;
      }
      return true;
    }

    return false;
  } catch (error) {
    TokenRepository.remove();
    return false;
  }
};
